import { createContext, ReactNode, useEffect, useState } from 'react';

interface InstallPwaContextValue {
  supportsPWA: boolean;
  installPwa: () => Promise<void>;
}

export const InstallPwaContext = createContext<InstallPwaContextValue>({
  supportsPWA: false,
  installPwa: async () => {},
});

interface Props {
  children: ReactNode;
}

const InstallPwaProvider = ({ children }: Props) => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const handler = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const handleInstalled = () => {
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handler as EventListener);
    window.addEventListener('appinstalled', handleInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler as EventListener);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const installPwa = async () => {
    if (!deferredPrompt) {
      alert(
        "Pour installer l'application, veuillez utiliser l'option 'Ajouter à l'écran d'accueil' de votre navigateur."
      );
      return;
    }

    await deferredPrompt.prompt();
    setDeferredPrompt(null);
  };

  return (
    <InstallPwaContext.Provider value={{ supportsPWA: deferredPrompt !== null, installPwa }}>
      {children}
    </InstallPwaContext.Provider>
  );
};

export default InstallPwaProvider;
